module.exports = __webpack_public_path__ + "img/img-3.0b904ee8.jpg";